var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import AccountManagementMainHeader from '@/modules/admin/components/AccountManagementModal/AccountManagementMainHeader.vue';
import AccountManagementCreditsTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementCreditsTab/AccountManagementCreditsTab.container.vue';
import AccountManagementCreditsConsumptionContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementCreditsConsumptionTab/AccountManagementCreditsConsumptionTab.container.vue';
import AccountManagementUsersTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementUsersTab/AccountManagementUsersTab.container.vue';
import AccountManagementAuditsTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementAuditsTab/AccountManagementAuditsTab.container.vue';
import AccountManagementAccountInfoTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementAccountInfoTab/AccountManagementAccountInfoTab.container.vue';
import AccountManagementUserBehaviorTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementUserBehaviorTab/AccountManagementUserBehaviorTab.container.vue';
import AccountManagementReportsTabContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementReportsTab/AccountManagementCreditsTab/AccountManagementReportsTab.container.vue';
import AccountManagementFeatureFlagsTab from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementFeatureFlagsTab/AccountManagementFeatureFlagsTab.container.vue';
let AccountManagementMainContainer = class AccountManagementMainContainer extends Vue {
    closeModal() {
        this.$emit('closeModal');
        this.$store.dispatch('admin/update_left_tab_of_modal', null);
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
        this.$store.dispatch('admin/select_account', { accountId: null });
        this.$store.dispatch('admin/select_user', { userId: null });
    }
    headerSectionTitle() {
        switch (this.leftTabOfModal) {
            case 'credits':
                return 'Gerenciar Crédito';
            case 'credits-consumption':
                return 'Consumo da Conta';
            case 'users':
                return 'Usuários';
            case 'account-info':
                return 'Informações da Conta';
            case 'audits':
                return 'Auditoria';
            case 'user-behavior':
                return 'Comportamento do Usuário';
            case 'reports':
                return 'Relatórios';
            case 'feature-flags':
                return 'Funcionalidades Liberadas';
            default:
                return 'Gerenciar Crédito';
        }
    }
    closeRightDrawer() {
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
    }
    get leftTabOfModal() {
        return this.$store.getters['admin/get_left_tab_of_modal'] || 'credits';
    }
    set leftTabOfModal(value) {
        this.$store.dispatch('admin/update_left_tab_of_modal', value);
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
        this.refreshAccountInfo();
    }
    // BUG (ticket "saldo de exportação não atualiza nos painéis"): o resumo de
    // créditos do cabeçalho (Cliques/Exportações) só era buscado ao abrir a
    // conta (AccountManagementModal.container.vue#initData) ou logo após
    // Adicionar/Remover crédito (AccountManagementCreditsForm.vue#creditsChange)
    // — nunca ao trocar de aba. Como o saldo pode mudar por consumo do usuário
    // ou pela sincronia com o legado enquanto o modal já está aberto, o admin
    // via um número congelado ao entrar em Consumo/Auditoria. Reaproveita a
    // mesma action já usada nesses dois pontos; não bloqueia a troca de aba.
    refreshAccountInfo() {
        const accountId = this.$store.getters['admin/get_selected_account'];
        if (!accountId)
            return;
        this.$store.dispatch('admin/fetch_account_info', { accountId });
    }
    get rightTabOfModal() {
        return this.$store.getters['admin/get_right_tab_of_modal'];
    }
};
AccountManagementMainContainer = __decorate([
    Component({
        components: {
            AccountManagementMainHeader,
            AccountManagementCreditsTabContainer,
            AccountManagementCreditsConsumptionContainer,
            AccountManagementUsersTabContainer,
            AccountManagementAuditsTabContainer,
            AccountManagementAccountInfoTabContainer,
            AccountManagementUserBehaviorTabContainer,
            AccountManagementReportsTabContainer,
            AccountManagementFeatureFlagsTab,
        },
    })
], AccountManagementMainContainer);
export default AccountManagementMainContainer;
